"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = exports.AlertIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("@digital-hig/alert/lib/constants");

var _alertOutline = _interopRequireDefault(require("@digital-hig/icon/lib/build/icons/utility/alert-outline"));

var _alert = _interopRequireDefault(require("@digital-hig/icon/lib/build/display-icons/alert"));

var _complete = _interopRequireDefault(require("@digital-hig/icon/lib/build/icons/utility/complete"));

var _complete2 = _interopRequireDefault(require("@digital-hig/icon/lib/build/display-icons/complete"));

var _cross = _interopRequireDefault(require("@digital-hig/icon/lib/build/icons/utility/cross"));

var _errorOutline = _interopRequireDefault(require("@digital-hig/icon/lib/build/icons/utility/error-outline"));

var _error = _interopRequireDefault(require("@digital-hig/icon/lib/build/display-icons/error"));

var _svgIcon = _interopRequireDefault(require("@digital-hig/svg-icon"));

var _infoOutline = _interopRequireDefault(require("@digital-hig/icon/lib/build/icons/utility/info-outline"));

var _info = _interopRequireDefault(require("@digital-hig/icon/lib/build/display-icons/info"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore file */
var AlertIcon = function AlertIcon(_ref) {
  var alt = _ref.alt,
      severity = _ref.severity,
      variant = _ref.variant;
  var icon;

  if (variant === _constants.variants.LOUD) {
    switch (severity) {
      case _constants.severities.INFO:
        {
          icon = /*#__PURE__*/_react.default.createElement(_infoOutline.default, null);
          break;
        }

      case _constants.severities.ERROR:
        {
          icon = /*#__PURE__*/_react.default.createElement(_errorOutline.default, null);
          break;
        }

      case _constants.severities.SUCCESS:
        {
          icon = /*#__PURE__*/_react.default.createElement(_complete.default, null);
          break;
        }

      case _constants.severities.WARNING:
        {
          icon = /*#__PURE__*/_react.default.createElement(_alertOutline.default, null);
          break;
        }

      default:
        {
          return null;
        }
    }
  } else {
    switch (severity) {
      case _constants.severities.INFO:
        {
          icon = /*#__PURE__*/_react.default.createElement(_info.default, null);
          break;
        }

      case _constants.severities.ERROR:
        {
          icon = /*#__PURE__*/_react.default.createElement(_error.default, null);
          break;
        }

      case _constants.severities.SUCCESS:
        {
          icon = /*#__PURE__*/_react.default.createElement(_complete2.default, null);
          break;
        }

      case _constants.severities.WARNING:
        {
          icon = /*#__PURE__*/_react.default.createElement(_alert.default, null);
          break;
        }

      default:
        {
          return null;
        }
    }
  }

  return /*#__PURE__*/_react.default.createElement(_svgIcon.default, {
    alt: alt
  }, icon);
};

exports.AlertIcon = AlertIcon;
AlertIcon.propTypes = {
  alt: _propTypes.default.string,
  severity: _propTypes.default.oneOf(_constants.availableSeverities).isRequired,
  variant: _propTypes.default.oneOf(_constants.availableVariants)
};

var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/_react.default.createElement(_cross.default, null);
};

exports.CloseIcon = CloseIcon;
AlertIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AlertIcon",
  "props": {
    "alt": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "severity": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableSeverities"
      },
      "required": true,
      "description": ""
    },
    "variant": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableVariants"
      },
      "required": false,
      "description": ""
    }
  }
};
CloseIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CloseIcon"
};